import type { ExpertiseCard } from '@/types';

export const EXPERTISE_CARDS: ExpertiseCard[] = [
  {
    id:          'inspection',
    number:      'NO. 01 · INSPECTION',
    category:    'Dimensional Inspection',
    icon:        'Gauge',
    title:       'Dimensional Inspection',
    items:       [
      'Hexagon arm · CMM · FARO',
      'Conventional instruments — micrometers, calipers, gauges',
      'GD&T · geometric tolerancing · ISO / ASME',
      'Paint control — thickness, anchor profile, pull-off testing',
      'Hold points and final inspections per PRIE/ITP',
      'Reading complex drawings — machining, welding, hydroelectric',
    ],
    footer:      'Hydroelectric dam components · Mazak V655-60 / V515',
    accentClass: 'p',
  },
  {
    id:          'qualite',
    number:      'NO. 02 · QUALITY',
    category:    'ISO 9001 Quality System',
    icon:        'ShieldCheck',
    title:       'ISO 9001 Quality System',
    items:       [
      'PRIE · ITP · RIF · NCR — building complete quality packages',
      'Final packages — NDT, paint, welding, blasting, heat treatment, packaging',
      'Non-conformity handling and corrective actions',
      'ISO audits · management reviews · continuous improvement',
      '5S · FMEA · Pareto · 5 Whys',
      'Quality KPIs — built and tracked in PowerBI / advanced Excel',
    ],
    footer:      'Quality system rebuilt at CNC Tracy Inc. — 2023',
    accentClass: 'a',
  },
  {
    id:          'transformation',
    number:      'NO. 03 · TRANSFORMATION',
    category:    'Digital Transformation',
    icon:        'Brain',
    title:       'Digital Transformation',
    items:       [
      'Automated quality reports and inspection packages',
      'Eliminating non-value-added work — re-keying, recopying',
      'Tools built for the actual job, wired into the existing ERP',
      'Company brain — an industrial knowledge base',
      'Precise answers to real problems, not demos',
      'Applied AI — Claude API · Gemini API · local models',
    ],
    footer:      'Founder of Asterion Solutions · OSEntreprendre 2026 laureate',
    accentClass: 't',
  },
  {
    id:          'gmao',
    number:      'NO. 04 · MAINTENANCE',
    category:    'CMMS & Planning',
    icon:        'Settings2',
    title:       'CMMS & Planning',
    items:       [
      'ERP: Notixia · Genius · MS Project',
      'Setting up and running a CMMS tied into the ERP',
      'Structuring the machine / building hierarchy',
      'MTBF · MTTR · OEE · automated reporting',
      'Preventive and corrective maintenance · work order handling',
      'Gantt planning · Kanban · scheduled shutdowns',
    ],
    footer:      'CMMS integrated with the Notixia ERP — CNC Tracy, 2023',
    accentClass: 'am',
  },
  {
    id:          'dev',
    number:      'NO. 05 · DEV',
    category:    'Development & Deployment',
    icon:        'Server',
    title:       'Development & Deployment',
    items:       [
      'Structured development — React 19, strict TypeScript, Vite',
      'Firebase (Hosting · Firestore · Auth) · GitLab · Git',
      'On-premises deployment — apps on dedicated servers, internal network',
      'Local ERP integration — apps wired to Notixia and Genius',
      'Microsoft 365 — Power Automate, PowerApps, API integrations',
      'Multi-tenant SaaS — Asterion Solutions, 6 apps in production',
    ],
    footer:      'Asterion Solutions · internal CNC Tracy tools deployed',
    accentClass: 'ci',
  },
  {
    id:          'cao',
    number:      'NO. 06 · CAD & DATA',
    category:    'CAD/Drafting · Data Analysis',
    icon:        'BarChart3',
    title:       'CAD/Drafting · Data Analysis',
    items:       [
      'SolidWorks · SolidEdge · CATIA V5/V6',
      '3D modeling · detail drawings · technical documentation',
      'Functional dimensioning and geometric tolerancing (GD&T)',
      'PowerBI — KPI dashboards · performance · reliability',
      'Advanced Excel — complex formulas, macros, automation',
      'Office 365 suite — Word, Project, Teams, advanced SharePoint',
    ],
    footer:      'Mechanical Engineering diploma (Toulouse, 2012) · ÉNA Tolerancing (2018)',
    accentClass: 'm',
  },
];
